import { AppointmentMessageState } from './types';

export const state = (): AppointmentMessageState => initialState();

export const initialState = (): AppointmentMessageState => ({
  messages: [],
  isLoading: false,
});
